export enum BillingSubFeatures {
  INVOICES = 'invoices',
  PAYMENTS_AND_PLANS = 'payments-plans',
  COMMISSIONS = 'commissions',
}
